import React from 'react';
import {
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
} from '@mui/material';

// MESSAGES
import ExpiredCardsFormattedMessages from '../../../messages/billing/ExpiredCardsFormattedMessages';

const ExpiredCardTable = ({ list }) => {
  return (
    <TableContainer sx={{ marginBottom: 4, overflowX: 'auto', width: '100%' }}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>{ExpiredCardsFormattedMessages.account}</TableCell>
            <TableCell>{ExpiredCardsFormattedMessages.name}</TableCell>
            <TableCell>{ExpiredCardsFormattedMessages.email}</TableCell>
            <TableCell>{ExpiredCardsFormattedMessages.phone}</TableCell>
            <TableCell>{ExpiredCardsFormattedMessages.nameOnCard}</TableCell>
            <TableCell>{ExpiredCardsFormattedMessages.cardType}</TableCell>
            <TableCell>{ExpiredCardsFormattedMessages.cardNumber}</TableCell>
            <TableCell>{ExpiredCardsFormattedMessages.expiry}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>{list}</TableBody>
      </Table>
    </TableContainer>
  );
};

export default ExpiredCardTable;
